export { default } from './StickyCTAPanel';
export type { StickyCTAPanelConfig } from './StickyCTAPanel';
